// // src/contexts/StockScreenerContext.js
// import React, { createContext } from 'react';
// import { useLocalStorage } from '../hooks/useLocalStorage';

// export const StockScreenerContext = createContext();

//  // Default stocks to load on initial render
//  const DEFAULT_STOCKS = ['AAPL', 'GOOGL', 'MSFT', 'AMZN', 'TSLA', 'NVDA', 'META', 'NFLX', 'CRM', 'ADBE'];


// // Default metrics to display
// const DEFAULT_METRICS = [
//   { label: "Price to Earnings Ratio", key: "priceEarningsRatio" },
//   { label: "Gross Profit Margin", key: "grossProfitMargin" },
//   { label: "Net Profit Margin", key: "netProfitMargin" },
// ];

// export function StockScreenerProvider({ children }) {
//   // const [screenedStocks, setScreenedStocks] = useLocalStorage('screenerStocks', []);
//   const [screenedStocks, setScreenedStocks] = useLocalStorage('screenerStocks', DEFAULT_STOCKS);

//   const [selectedForComparison, setSelectedForComparison] = useLocalStorage('screenerSelectedForComparison', []);
//   const [selectedMetrics, setSelectedMetrics] = useLocalStorage('screenerSelectedMetrics', DEFAULT_METRICS);
//   const [metricsData, setMetricsData] = useLocalStorage('screenerMetricsData', {});
//   const [activeFilters, setActiveFilters] = useLocalStorage('screenerActiveFilters', []);

//   // Helper methods for managing screened stocks
//   const addStock = (symbol) => {
//     setScreenedStocks(stocks => 
//       stocks.includes(symbol) ? stocks : [...stocks, symbol]
//     );
//   };

//   const removeStock = (symbol) => {
//     setScreenedStocks(stocks => stocks.filter(s => s !== symbol));
//     setSelectedForComparison(selected => selected.filter(s => s !== symbol));
//     // Remove metrics data for the removed stock
//     setMetricsData(data => {
//       const newData = { ...data };
//       delete newData[symbol];
//       return newData;
//     });
//   };

//   const clearAllStocks = () => {
//     setScreenedStocks([]);
//     setSelectedForComparison([]);
//     setMetricsData({});
//   };

//   // Helper methods for comparison selection
//   const toggleSelection = (symbol) => {
//     setSelectedForComparison(selected => 
//       selected.includes(symbol) 
//         ? selected.filter(s => s !== symbol) 
//         : [...selected, symbol]
//     );
//   };

//   const clearSelection = () => {
//     setSelectedForComparison([]);
//   };

//   // Helper methods for metrics data
//   const updateMetricsData = (symbol, data) => {
//     setMetricsData(prev => ({
//       ...prev,
//       [symbol]: data
//     }));
//   };

//   const clearMetricsData = () => {
//     setMetricsData({});
//   };

//   // Helper methods for filters
//   const clearFilters = () => {
//     setActiveFilters([]);
//   };

//   // Helper method to check if stock is already screened
//   const isStockScreened = (symbol) => {
//     return screenedStocks.includes(symbol);
//   };

//   const contextValue = {
//     // State
//     screenedStocks,
//     selectedForComparison,
//     selectedMetrics,
//     metricsData,
//     activeFilters,
    
//     // Stock management
//     addStock,
//     removeStock,
//     clearAllStocks,
//     isStockScreened,
    
//     // Comparison selection
//     toggleSelection,
//     clearSelection,
    
//     // Metrics management
//     setSelectedMetrics,
//     updateMetricsData,
//     clearMetricsData,
    
//     // Filter management
//     setActiveFilters,
//     clearFilters,
    
//     // Direct setters (if needed)
//     setScreenedStocks,
//     setSelectedForComparison,
//     setMetricsData,
//   };

//   return (
//     <StockScreenerContext.Provider value={contextValue}>
//       {children}
//     </StockScreenerContext.Provider>
//   );
// }

// src/contexts/StockScreenerContext.js
import React, { createContext } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { METRIC_FIELDS } from '../constants/metricFields';

export const StockScreenerContext = createContext();

// Default metrics to display (P/E, Gross margin, Net margin)
const DEFAULT_METRIC_KEYS = [
  'priceToEarningsRatio',
  'grossProfitMargin',
  'netProfitMargin'
];

const DEFAULT_METRICS = METRIC_FIELDS
  .filter(m => DEFAULT_METRIC_KEYS.includes(m.value))
  .map(m => ({ label: m.label, key: m.value }));

export function StockScreenerProvider({ children }) {
  // Stocks in the screener table
  const [screenedStocks, setScreenedStocks] = useLocalStorage(
    'screenerStocks',
    [] // will be auto-filled from /list-stocks-search
  );

  // Comparison selection
  const [selectedForComparison, setSelectedForComparison] = useLocalStorage(
    'screenerSelectedForComparison',
    []
  );

  // Which metrics columns are shown in the table
  const [selectedMetrics, setSelectedMetrics] = useLocalStorage(
    'screenerSelectedMetrics',
    DEFAULT_METRICS
  );

  // Latest metrics snapshot per stock (one object per symbol)
  const [metricsData, setMetricsData] = useLocalStorage(
    'screenerMetricsData',
    {}
  );

  // Active slider filters in the sidebar
  const [activeFilters, setActiveFilters] = useLocalStorage(
    'screenerActiveFilters',
    []
  );

  // --- Stock management ---

  const addStock = (symbol) => {
    setScreenedStocks(stocks =>
      stocks.includes(symbol) ? stocks : [...stocks, symbol]
    );
  };

  const removeStock = (symbol) => {
    setScreenedStocks(stocks => stocks.filter(s => s !== symbol));
    setSelectedForComparison(selected => selected.filter(s => s !== symbol));

    setMetricsData(data => {
      const newData = { ...data };
      delete newData[symbol];
      return newData;
    });
  };

  const clearAllStocks = () => {
    setScreenedStocks([]);
    setSelectedForComparison([]);
    setMetricsData({});
  };

  const isStockScreened = (symbol) => screenedStocks.includes(symbol);

  // --- Comparison selection ---

  const toggleSelection = (symbol) => {
    setSelectedForComparison(selected =>
      selected.includes(symbol)
        ? selected.filter(s => s !== symbol)
        : [...selected, symbol]
    );
  };

  const clearSelection = () => {
    setSelectedForComparison([]);
  };

  // --- Metrics data management ---

  const updateMetricsData = (symbol, data) => {
    setMetricsData(prev => ({
      ...prev,
      [symbol]: data
    }));
  };

  const clearMetricsData = () => {
    setMetricsData({});
  };

  // --- Filter management ---

  const clearFilters = () => {
    setActiveFilters([]);
  };

  const contextValue = {
    // State
    screenedStocks,
    selectedForComparison,
    selectedMetrics,
    metricsData,
    activeFilters,

    // Stock management
    addStock,
    removeStock,
    clearAllStocks,
    isStockScreened,

    // Comparison selection
    toggleSelection,
    clearSelection,

    // Metrics management
    setSelectedMetrics,
    updateMetricsData,
    clearMetricsData,

    // Filter management
    setActiveFilters,
    clearFilters,

    // Direct setters if needed
    setScreenedStocks,
    setSelectedForComparison,
    setMetricsData
  };

  return (
    <StockScreenerContext.Provider value={contextValue}>
      {children}
    </StockScreenerContext.Provider>
  );
}
